/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NameDto } from '../../models/name-dto';

export interface EmployeeControllerFindAllDropdown$Params {
  officeId?: number;
  initial: boolean;
  sIds?: Array<number>;
  housingId?: number;
}

export function employeeControllerFindAllDropdown(http: HttpClient, rootUrl: string, params: EmployeeControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDto>>> {
  const rb = new RequestBuilder(rootUrl, employeeControllerFindAllDropdown.PATH, 'get');
  if (params) {
    rb.query('officeId', params.officeId, {});
    rb.query('initial', params.initial, {});
    rb.query('sIds', params.sIds, {});
    rb.query('housingId', params.housingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NameDto>>;
    })
  );
}

employeeControllerFindAllDropdown.PATH = '/api/employee/dropdown';
